import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { EventManager } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CartaoCredito, ICartaoCredito } from 'src/app/shared/models/cartao-credito.model';
import { IConfiguracao } from 'src/app/shared/models/configuracao.model';
import { CompraService } from 'src/app/shared/services/compra.service';
import { DataUtils } from 'src/app/shared/util/data-util.service';
import { SuccessModalComponent } from '../../../components/success-modal/success-modal.component';
import { Compra, ICompra } from 'src/app/shared/models/compra.model';
import { DadosUsuarioService } from 'src/app/shared/services/dados-usuario.service';
import { HttpResponse } from '@angular/common/http';
import dayjs from 'dayjs';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ConfiguracaoService } from 'src/app/shared/services/configuracao.service';
import { UtilsCompraService } from 'src/app/shared/services/utils-compra.service';
import { CadastroCartao, ICadastroCartao } from 'src/app/shared/models/cadastro-cartao';
import { CartaoCreditoService } from 'src/app/shared/services/cartao-credito.service';
import { PagarmeService } from 'src/app/shared/services/pagarme.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { EnderecoService } from 'src/app/shared/services/endereco.service';
import { Endereco, IEndereco } from 'src/app/shared/models/endereco.model';
import { IDadosUsuario } from 'src/app/shared/models/dados-usuario.model';
import { Projeto } from 'src/app/shared/models/projeto.model';
import { ProjetoService } from 'src/app/shared/services/projeto.service';
import { NgClass } from '@angular/common';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgxMaskDirective } from 'ngx-mask';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
  selector: 'app-comprar',
  templateUrl: './comprar.component.html',
  styleUrls: ['./comprar.component.scss'],
  standalone: true,
  imports: [MatFormField, MatLabel, MatInput, NgxMaskDirective, FormsModule, ReactiveFormsModule, NgClass, MatCheckbox, NgxCurrencyDirective, RouterLink, TranslateModule, MatDialogModule]
})
export class ComprarComponent implements OnInit {
  currentUser: IDadosUsuario;
  currentCompensate: boolean = true;
  isInformed = false;
  isSaving = false;
  isLoading = false;
  pix = false;
  credito = false;
  compraOld = false;
  creditos?;
  configuracao?: IConfiguracao;
  cartoes?: ICartaoCredito[];

  projetoForm = this.fb.group({
    id: [],
    timestamp: [],
    dataAtualizacao: [],
    nome: new FormControl('', Validators.required),
    razaoSocial: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.email, Validators.required]),
    telefone: new FormControl('', Validators.required),
    calculo: new FormControl('', Validators.required),
    titulo: new FormControl(),
    descricao: new FormControl('', Validators.required),
    observacao: new FormControl('', Validators.required),
    cpfCnpj: new FormControl('', Validators.required),
  });

  brcFormControl = new FormControl('', [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]*$")]);
  documentoFormControl = new FormControl('', [Validators.required]);
  readonly formGroup = this.fb.group({
    brc: this.brcFormControl,
    documento: this.documentoFormControl,
  });
  parcelas: any[] = [];

  certificadoAutomatico: boolean = false;

  nomeDestinatario = '';
  cpfCnpjDestinatario = '';
  produtoscarrinho;
  qrcode = "";
  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: { data: number, quantidadeKgCo2: number, isFromCarrinho: boolean },
    public dialog: MatDialog,
    // public dialogRef: MatDialogRef<ComprarComponent>,

    protected fb: UntypedFormBuilder,
    protected dataUtils: DataUtils,
    protected eventManager: EventManager,
    protected comprarService: CompraService,
    protected elementRef: ElementRef,
    protected activatedRoute: ActivatedRoute,
    protected dadosUsuarioService: DadosUsuarioService,
    protected router: Router,
    protected cartaoService: CartaoCreditoService,
    protected pagarmeService: PagarmeService,
    protected enderecoService: EnderecoService,
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private configuracaoService: ConfiguracaoService,
    private utilsCompraService: UtilsCompraService,
    private translate: TranslateService,
    private projetoService: ProjetoService
  ) {
    let cadastroCartao = new CadastroCartao();
    this.updateForm(cadastroCartao);
  }

  editForm = this.fb.group({
    cartao: ['', Validators.required],
    vencimento: ['', Validators.required],
    ccv: ['', Validators.required],
    nomecartao: ['', Validators.required],
    documento: ['', Validators.required],
  });

  enderecoForm = this.fb.group({
    rua: ['', Validators.required],
    bairro: ['', Validators.required],
    numero: ['', Validators.required],
    cep: ['', Validators.required],
    cidade: ['', Validators.required],
    uf: ['', Validators.required],
    complemento: [''],
  });

  selectedEstado;
  listOfEstados = [
    { value: 'AC', label: 'Acre' },
    { value: 'AL', label: 'Alagoas' },
    { value: 'AP', label: 'Amapá' },
    { value: 'AM', label: 'Amazonas' },
    { value: 'BA', label: 'Bahia' },
    { value: 'CE', label: 'Ceará' },
    { value: 'DF', label: 'Distrito Federal' },
    { value: 'ES', label: 'Espírito Santo' },
    { value: 'GO', label: 'Goías' },
    { value: 'MA', label: 'Maranhão' },
    { value: 'MT', label: 'Mato Grosso' },
    { value: 'MS', label: 'Mato Grosso do Sul' },
    { value: 'MG', label: 'Minas Gerais' },
    { value: 'PA', label: 'Pará' },
    { value: 'PB', label: 'Paraíba' },
    { value: 'PR', label: 'Paraná' },
    { value: 'PE', label: 'Pernambuco' },
    { value: 'PI', label: 'Piauí' },
    { value: 'RJ', label: 'Rio de Janeiro' },
    { value: 'RN', label: 'Rio Grande do Norte' },
    { value: 'RS', label: 'Rio Grande do Sul' },
    { value: 'RO', label: 'Rondônia' },
    { value: 'RR', label: 'Roraíma' },
    { value: 'SC', label: 'Santa Catarina' },
    { value: 'SP', label: 'São Paulo' },
    { value: 'SE', label: 'Sergipe' },
    { value: 'TO', label: 'Tocantins' },
  ]
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  ngOnInit() {
    this.utilsCompraService.loadConfigurations()
    this.utilsCompraService.buscaDadosUsuario();
    this.dadosUsuarioService.query().subscribe(res => {
      this.currentUser = res.body[0] ?? {};
      const fullName = (this.capitalizeFirstLetter(this.currentUser.user.firstName) + ' ' + this.capitalizeFirstLetter(this.currentUser.user.lastName));
      this.projetoForm.reset();
      this.projetoForm.get('nome').setValue(fullName);
      this.projetoForm.get('razaoSocial').setValue(this.currentUser.razaoSocial);
      this.projetoForm.get('email').setValue(this.currentUser.user.email);
      this.projetoForm.get('telefone').setValue(this.currentUser.user.login);
      this.projetoForm.get('cpfCnpj').setValue(this.currentUser.documento);
    })
    this.produtoscarrinho = this.utilsCompraService.getCarrinho();

  }

  selectEstado(event) {
    this.selectedEstado = event.value;
  }

  //   onSubmitCheckout() {
  //     //preencher dados da compra
  //     if (this.utilsCompraService.configuracao.quantidadePossivelVenda >= this.formGroup.get('brc').value) {
  //       //this.save();
  //       this.isSaving = true;
  //       if (this.pix === true) {
  //         this.salvarComPix();
  //         return;
  //       }
  //       if (this.credito === true) {
  //         this.salvarCredito();
  //         return;
  //       }
  //     } else {
  //       alert("Não há BRC disponível em nosso estoque para esse total de compensação!");
  //       return;
  //     }
  //   }

  protected onSaveFinalize(): void {
    this.isSaving = false;
  }
  protected onSaveError(e): void {
    // Api for inheritance.
    alert("Ocorreu um erro ao enviar a solicitação de compra! " + e ? e.error.descricao : '');
    // this.dialogRef.close();
  }

  deleteFromCache() {
    this.produtoscarrinho = [];
    this.$localStorage.clear("carrinhocompras");
    this.$sessionStorage.clear("carrinhocompras");

    this.$localStorage.clear("qrcode");
    this.$sessionStorage.clear("qrcode");
  }

  protected onSaveSuccess(r): void {
    if (!r.body.pagamento.qrCodeString) {
      if (r.body.statusCompra === "approved" || r.body.statusCompra === "paid") {
        this.deleteFromCache();
        this.onPaymentSuccess();
        // this.onNoClick();
        return;
      }
      if (r.body.statusCompra === "failed") {
        this.deleteFromCache();
        alert("Falha na compra tente novamente!");
        // this.dialogRef.close();
        return;
      }
    }
    if (r.body.pagamento.qrCodeString.indexOf('qr_code') > -1 || r.body.descricao.indexOf('qr_code') > -1) { //encontrou o qrcode
      this.qrcode = r.body.pagamento.qrCodeString ? r.body.pagamento.qrCodeString.substr(8) : r.body.descricao.substr(8);
      if (!this.utilsCompraService.isSancorClientes) {
        // this.onPaymentSuccess();
      } else {
        // this.onPaymentSuccess();
        alert('Compra solicitada com sucesso, os créditos estão sendo processados e vão incrementar seu saldo em breve, por favor aguarde!');
      }
    }
    this.deleteFromCache();
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<ICompra>>): void {
    result.pipe(finalize(() => this.onSaveFinalize())).subscribe(
      (r) => this.onSaveSuccess(r),
      (e) => this.onSaveError(e)
    );
  }

  //   async salvarComPix() {
  //     let compra: ICompra = new Compra();
  //     let pegadaCo2 = this.data.quantidadeKgCo2 * 1000;
  //     compra.descricao = `Compensar ${pegadaCo2} kg de CO2`;

  //     if (this.data.isFromCarrinho != true) {
  //       pegadaCo2 = Math.ceil(this.formGroup.get('brc').value * 1000);
  //       compra.descricao = `Compra de ${this.formGroup.get('brc').value} brcs`;
  //     }
  //     let custocompensacao = ((pegadaCo2) * (this.utilsCompraService.configuracao.valorVenda / 1000));
  //     compra.certificadoAutomatico = this.certificadoAutomatico ? "S" : "N";
  //     compra.quantidade = pegadaCo2;
  //     compra.valorTotal = custocompensacao;
  //     compra.valorCredito = this.utilsCompraService.configuracao.valorVenda;
  //     compra.timestamp = dayjs(new Date());
  //     // this.produtoscarrinho.forEach(e => {
  //     //   if (e.nomeDestinatario != "") {
  //     //     this.nomeDestinatario = e.nomeDestinatario;
  //     //     this.cpfCnpjDestinatario = e.cpfCnpjDestinatario;
  //     //   }
  //     // })

  //     if (this.nomeDestinatario != '' && this.cpfCnpjDestinatario != '') {
  //       compra.nomeDestinatario = this.nomeDestinatario;
  //       compra.cpfCnpjDestinatario = this.cpfCnpjDestinatario.replace(/[.///-]/g, '')
  //     } else {
  //       compra.nomeDestinatario = this.utilsCompraService.dadosUsuario.nome != "" ? this.utilsCompraService.dadosUsuario.nome : this.utilsCompraService.dadosUsuario.razaoSocial;
  //       compra.cpfCnpjDestinatario = this.utilsCompraService.dadosUsuario.documento != '' ? this.utilsCompraService.dadosUsuario.documento : this.formGroup.get('documento').value;
  //     }
  //
  //     this.subscribeToSaveResponse(this.comprarService.createB2C(compra));
  //   }


  protected updateForm(cartaoCredito: ICadastroCartao): void {
    this.editForm.patchValue({
      cartao: cartaoCredito.cartao,
      vencimento: cartaoCredito.vencimento,
      ccv: cartaoCredito.ccv,
      nomecartao: cartaoCredito.nomecartao,
      documento: cartaoCredito.documento,
    });

  }


  protected createCardFromForm(): ICadastroCartao {
    return {
      ...new CadastroCartao(),
      cartao: this.editForm.get(['cartao'])!.value,
      vencimento: this.editForm.get(['vencimento'])!.value,
      ccv: this.editForm.get(['ccv'])!.value,
      nomecartao: this.editForm.get(['nomecartao'])!.value,
      documento: this.editForm.get(['documento'])!.value
    };
  }

  protected createEnderecoFromForm(): IEndereco {
    return {
      ...new Endereco(),
      logradouro: this.enderecoForm.get(['numero'])!.value + ', ' + this.enderecoForm.get(['rua'])!.value + ', ' + this.enderecoForm.get(['bairro'])!.value,
      cep: this.enderecoForm.get(['cep'])!.value,
      cidade: this.enderecoForm.get(['cidade'])!.value,
      uf: this.enderecoForm.get(['uf'])!.value,
      complemento: this.enderecoForm.get(['complemento'])!.value
    };
  }

  //   salvarCredito() {
  //     if (!this.editForm.valid) {
  //       alert('Dados invalidos, preencha os campos corretamente.');
  //       return;
  //     }
  //     if(!this.enderecoForm.valid){
  //         alert('Existem dados invalidos no endereco')
  //     }
  //     this.isLoading = true;
  //     const cartaoCredito = this.createCardFromForm();
  //     const endereco = this.createEnderecoFromForm();

  //     let token = this.pagarmeService.getToken(cartaoCredito).subscribe(
  //       (res: HttpResponse<any>) => {
  //         let cartaoCreditoSalvar: ICartaoCredito = new CartaoCredito();
  //         cartaoCreditoSalvar.token = res.body.id;
  //         cartaoCreditoSalvar.primeirosdigitos = res.body.card.first_six_digits;
  //         cartaoCreditoSalvar.documento = res.body.card.holder_document;
  //         cartaoCreditoSalvar.expiration_month = res.body.card.exp_month;
  //         cartaoCreditoSalvar.expiration_year = res.body.card.exp_year;
  //         cartaoCreditoSalvar.name = res.body.card.holder_name;

  //         let cstemp = this.cartaoService.create(cartaoCreditoSalvar).subscribe(cartao => {

  //           let compra: ICompra = new Compra();
  //           compra.cartaoCredito = cartao.body;
  //           let pegadaCo2 = this.data.quantidadeKgCo2 * 1000;
  //           compra.descricao = `Compensar ${pegadaCo2} kg de CO2`;

  //           if (this.data.isFromCarrinho != true) {
  //             pegadaCo2 = Math.ceil(this.formGroup.get('brc').value * 1000);
  //             compra.descricao = `Compra de ${this.formGroup.get('brc').value} brcs`;
  //           }

  //           let custocompensacao = ((pegadaCo2) * (this.utilsCompraService.configuracao.valorVenda / 1000));
  //           compra.certificadoAutomatico = this.certificadoAutomatico ? "S" : "N";
  //           compra.quantidade = pegadaCo2;
  //           compra.valorTotal = custocompensacao;
  //           compra.valorCredito = this.utilsCompraService.configuracao.valorVenda;
  //           compra.timestamp = dayjs(new Date());

  //           if (this.nomeDestinatario != '' && this.cpfCnpjDestinatario != '') {
  //             compra.nomeDestinatario = this.nomeDestinatario;
  //             compra.cpfCnpjDestinatario = this.cpfCnpjDestinatario.replace(/[.///-]/g, '')
  //           } else {
  //             compra.nomeDestinatario = this.utilsCompraService.dadosUsuario.nome != "" ? this.utilsCompraService.dadosUsuario.nome : this.utilsCompraService.dadosUsuario.razaoSocial;
  //             compra.cpfCnpjDestinatario = this.utilsCompraService.dadosUsuario.documento != '' ? this.utilsCompraService.dadosUsuario.documento : this.formGroup.get('documento').value;
  //           }

  //           this.subscribeToSaveResponse(this.comprarService.createB2C(compra, endereco));
  //           cstemp.unsubscribe();
  //         });
  //         token.unsubscribe();
  //       },
  //       (err) => {
  //         this.isLoading = false;
  //

  //         alert("Ocorreu um erro ao enviar a solicitação de compra! " +
  //           this.translate.instant(err.error.errors['request.card'] ? err.error.errors['request.card'][0] : err.error.errors['request.card.exp_month'][0]));
  //       },

  //     );
  //   }

  //   saveAdress(){
  //     this.isSaving = true;
  //     const endereco: IEndereco = this.createEnderecoFromForm();

  //   }

  //   onNoClick(): void {
  //     this.dialogRef.close();
  //   }

  //   paymentType(type: string) {
  //     if (confirm("Confirmar forma de pagamento ?")) {
  //       if (type === 'pix') {
  //         this.pix = true;
  //         this.credito = false;
  //         this.onSubmitCheckout();
  //         return;
  //       }
  //       this.credito = true;
  //       this.pix = false;
  //     }
  //   }

  //   brcQuantitySelected() {
  //     let brc = this.data.quantidadeKgCo2 / 1000;
  //     if (this.data.isFromCarrinho != true) {
  //       brc = Number(this.brcFormControl.value);
  //     }
  //     if(brc < 1){
  //         alert("Deve ser comprado um valor mínimo de 1 BRC!")
  //         return;
  //     }

  //     for (var i = 1; i <= 4; i++) {
  //       this.parcelas.push({
  //         value: i + 'x', viewValue: (brc / i)
  //       })
  //     }
  //     this.isInformed = true;
  //     if (this.formGroup.get('documento').value && !this.utilsCompraService.dadosUsuario.documento) {

  //       this.utilsCompraService.dadosUsuario.documento = this.formGroup.get('documento').value;
  //       this.dadosUsuarioService.update(this.utilsCompraService.dadosUsuario).subscribe(() => {
  //
  //       })
  //     }
  //   }

  goBack() {
    this.credito = false;
    this.pix = false;
  }

  onPaymentSuccess() {
    this.dialog.open(SuccessModalComponent, {
      data: { title: "Pagamento realizado", info: "Os créditos estão sendo processados e irão incrementar seu saldo em breve, por favor aguarde!." },
    });
    // this.dialogRef.close();
  }

  compensateToCurrent() {
    this.currentCompensate = true;

    const fullName = this.capitalizeFirstLetter(this.currentUser.user.firstName) + ' ' + this.capitalizeFirstLetter(this.currentUser.user.lastName);
    this.projetoForm.get(['nome']).setValue(fullName);
    this.projetoForm.get(['razaoSocial']).setValue(this.currentUser.razaoSocial);
    this.projetoForm.get(['email']).setValue(this.currentUser.user.email);
    this.projetoForm.get(['telefone']).setValue(this.currentUser.user.login);
    this.projetoForm.get(['telefone']).setErrors(null);
    this.projetoForm.get(['cpfCnpj']).setValue(this.currentUser.documento);
  }

  compensateToOther() {
    this.currentCompensate = false;
    this.projetoForm.reset();
    this.projetoForm.markAsUntouched();
  }
  documentSave() {
    this.isInformed = true;
    if (this.formGroup.get(['documento']).value && !this.utilsCompraService.dadosUsuario.documento) {

      this.utilsCompraService.dadosUsuario.documento = this.formGroup.get(['documento']).value;
      this.dadosUsuarioService.update(this.utilsCompraService.dadosUsuario).subscribe(() => {

      })
    }
  }

  save() {
    const brc = Number(this.projetoForm.get('calculo'));
    if (brc < 1) {
      alert("Deve ser comprado um valor mínimo de 1 BRC!")
      return;
    }
    if (!this.projetoForm.valid) {
      alert('Dados invalidos, preencha os campos corretamente.');
      return;
    }

    const projeto: Projeto = this.projetoForm.getRawValue();
    projeto.timestamp = dayjs(new Date());
    projeto.dataAtualizacao = dayjs(new Date());
    projeto.usuario = this.currentUser.user;
    projeto.certificadoAutomatico = this.certificadoAutomatico ? "S" : "N";
    this.projetoService.create(projeto).subscribe(
      (response) => { console.log(response) },
      (error) => { console.log(error) }
    );
    this.dialog.open(SuccessModalComponent, {
      data: { title: "Dados enviados", info: "Os dados foram enviado com sucesso e serão verificados e validados, entraremos em contato em breve!" },
    }).afterClosed().subscribe(() => this.router.navigate(['dashboard-comprador']));
    // this.dialogRef.close();
  }
}
